import { createFeatureSelector, createSelector } from "@ngrx/store";

import * as fromBasket from "../reducers/basket.reducer";

export const selectBasketState = createFeatureSelector<fromBasket.State>(
    fromBasket.basketFeatureKey,
);

export const selectIsInitialized = createSelector(
    selectBasketState,
    (basketState: fromBasket.State) => basketState.isInitialized,
);

export const selectCart = createSelector(
    selectBasketState,
    (basketState: fromBasket.State) => basketState.cart,
);

export const selectTotalItems = createSelector(
    selectBasketState,
    (basketState: fromBasket.State) => basketState.cart?.totalItems,
);

export const selectError = createSelector(
    selectBasketState,
    (basketState: fromBasket.State) => basketState.error,
);

export const selectHasErrors = createSelector(
    selectBasketState,
    (basketState: fromBasket.State) => {
        if (basketState.error.hasError) {
            return true;
        }
        const itemInError = basketState.cart?.items?.find(
            (item) => item["hasError"],
        );
        return !!itemInError;
    },
);

export const selectPending = createSelector(
    selectBasketState,
    (basketState: fromBasket.State) => basketState.pending,
);

export const selectBillingAddress = createSelector(
    selectBasketState,
    (basketState: fromBasket.State) => basketState.cart.billingAddress,
);

export const selectSagawaTimeslots = createSelector(
    selectBasketState,
    (basketState: fromBasket.State) =>
        basketState.cart.shippingAppointmentTimeslots,
);

export const selectTaxInvoice = createSelector(
    selectBasketState,
    (basketState: fromBasket.State) => basketState.cart.taxDetails?.taxInvoice,
);

export const selectCfdiProperties = createSelector(
    selectBasketState,
    (basketState: fromBasket.State) =>
        basketState.cart.taxDetails?.cfdiProperties,
);

export const basketQuery = {
    selectIsInitialized,
    selectCart,
    selectTotalItems,
    selectError,
    selectHasErrors,
    selectPending,
    selectBillingAddress,
    selectSagawaTimeslots,
    selectTaxInvoice,
    selectCfdiProperties,
};
